'use strict'

import http from './http-common'
import authHeader from './auth-header'
import useSWR from 'swr'
import utils from 'utils/utils.js'

const getAll = ({ attributes, include } = {}) => {
  const queryStringSlices = []
  if (attributes) {
    queryStringSlices.push(attributes.map(attribute => `attributes=${attribute}`)
      .join('&'))
  }
  if (include) {
    queryStringSlices.push(include.map(child => `include=${child}`)
      .join('&'))
  }

  const queryString = !utils.isEmpty(queryStringSlices)
    ? '?' + queryStringSlices.join('&')
    : ''
  return http.axiosClient.get('/users' + queryString, { headers: authHeader() })
}

const get = (id) => {
  return http.axiosClient.get(`/users/${id}`, { headers: authHeader() })
}

const create = (data) => {
  return http.axiosClient.post('/users', data, { headers: authHeader() })
}

const update = (id, data) => {
  return http.axiosClient.put(`/users/${id}`, data, { headers: authHeader() })
}

const updateProfile = (id, data) => {
  return http.axiosClient.put(`/users/profile/${id}`, data, { headers: authHeader() })
}

const remove = (id) => {
  return http.axiosClient.delete(`/users/${id}`, { headers: authHeader() })
}

const findByUsername = (username) => {
  return http.axiosClient.get(`/users?username=${username}`)
}

const findByEmail = (email) => {
  return http.axiosClient.get(`/users?email=${email}`)
}

export default {
  getAll,
  get,
  create,
  update,
  updateProfile,
  remove,
  findByUsername,
  findByEmail
}
